<template>
  <div class="el-col-24">
    <!-- 标题 -->
    <h5 class="warp-title">{{title}}机器人</h5>
    <div class="edit-content">
      <el-form :model="addForm" ref="addForm" :rules="addFormRule" class="my-form-style" label-position="left" label-width="auto">
        <el-form-item label="平台：" prop="platformType">
          <el-select v-model="addForm.platformType" placeholder="选择平台" @change="handlePlatformChange">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in platformList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查看显示：" prop="inOutFlag">
          <el-radio-group v-model="addForm.inOutFlag">
            <el-radio :label="0">内部查看</el-radio>
            <el-radio :label="1">外部查看</el-radio>
            <el-radio :label="2">内外部查看</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问答分类：" prop="typeId">
          <el-select v-model="addForm.typeId" placeholder="请选择">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.type"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否链接直接跳转：" prop="isHref">
          <el-radio-group v-model="addForm.isHref" @change="handleRadioChange">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="addForm.isHref === 0">
          <el-form-item label="问题描述：" prop="problem">
            <el-input placeholder="请输入二级分类问题描述" v-model="addForm.problem" :maxlength="100" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="问题回答：" prop="content">
            <myQuill :content="addForm.content" @getQuillContent="getQuillContent" />
          </el-form-item>
        </div>
        <div v-if="addForm.isHref === 1">
          <el-form-item label="链接标题：" prop="problem">
            <el-input placeholder="请输入链接标题" v-model="addForm.problem" :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="链接地址：" prop="content">
            <el-input placeholder="请输入链接地址" v-model="addForm.content" :maxlength="100"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="cancel">返 回</el-button>
          <el-button type="primary" @click="toSubmit" :loading="isAddLoading">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {addRobotTalk, editRobotTalk, getSelectProblemType, editReturnRobotTalk} from '../../api/robotManage/index'
export default {
  name: 'TalkRobotEdit',
  created () {
    // this.getSelectProblemListByPlatformType()
    this.editReturnRobotTalk()
  },
  computed: {
    platformList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      isAddLoading: false,
      options: [],
      title: this.$route.params.id ? '编辑' : '新增',
      id: Number(this.$route.params.id),
      addForm: {
        inOutFlag: 0,
        content: '',
        problem: '',
        typeId: '',
        isHref: 0,
        platformType: ''
      },
      addFormRule: {
        platformType: [
          {required: true, message: '请选择平台', trigger: ['blur', 'change']}
        ],
        inOutFlag: [
          {required: true, message: '请选择显示', trigger: ['blur', 'change']}
        ],
        typeId: [
          {required: true, message: '请选择问答分类', trigger: ['blur', 'change']}
        ],
        problem: [
          {required: true, message: '请填写完整', trigger: ['blur', 'change']}
        ],
        content: [
          {required: true, message: '请填写完整', trigger: ['blur', 'change']}
        ],
        isHref: [
          {required: true, message: '请选择是否直接链接跳转', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    handlePlatformChange (val) {
      this.addForm.typeId = ''
      this.getSelectProblemListByPlatformType(val)
    },
    // 实时获取富文本的值
    getQuillContent (content) {
      this.addForm.content = content
    },
    handleRadioChange (isHref) {
      if (this.id) {
        let data = {
          id: this.id
        }
        editReturnRobotTalk(data).then(res => {
          if (res.data.resultCode === 0) {
            if (isHref === 1 && res.data.resultData.isHref === 0) {
              this.addForm.content = ''
            } else {
              this.addForm.content = res.data.resultData.content
            }
          }
        })
      }
    },
    cancel () {
      this.$router.push({
        name: 'TalkRobot'
      })
    },
    toSubmit () {
      this.$refs['addForm'].validate(async valid => {
        if (valid) {
          try {
            this.isAddLoading = true
            let isEdit = Boolean(this.id)
            const {data} = isEdit ? await editRobotTalk(this.addForm) : await addRobotTalk(this.addForm)
            if (data.resultCode === 0) {
              this.$message.success(`${isEdit ? '编辑' : '新增'}成功`)
              this.cancel()
            } else {
              this.$message.error(data.resultMessage)
            }
          } catch (error) {
          } finally {
            this.isAddLoading = false
          }
        }
      })
    },
    getSelectProblemListByPlatformType (platformType) {
      getSelectProblemType({platformId: platformType}).then(res => {
        this.options = res.data.resultData
      })
    },
    editReturnRobotTalk () {
      if (!this.id) {
        return
      }
      let data = {
        id: this.id
      }
      editReturnRobotTalk(data).then(res => {
        if (res.data.resultCode === 0) {
          this.addForm = res.data.resultData
          this.getSelectProblemListByPlatformType(this.addForm.platformType)
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ql-container{
  min-height: 250px;
  max-height: 500px;
  overflow-y: auto;
}
/deep/.el-form-item__label-wrap{
  margin-left: 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Robot/TalkRobotEdit.vue